import { Box, Button, Form, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { useState } from 'react'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'
import { staticStrings } from '../../../data/static/strings'
import { Resend } from '../../SignupWeb/Resend'
import { otpForm } from './FormData'
import styles from './styles'

interface ValidateOTPModelProps {
  isModelDialogVisible: boolean
  onDismiss: any
  onOTPEntered: any
  resendOTP: any
  mobileNum: string
  isLoading: boolean
  testID: string
  error: string
  setSubmitOtpError: any
}

const ValidateOTPModel = ({
  isModelDialogVisible,
  onDismiss,
  onOTPEntered,
  resendOTP,
  mobileNum,
  isLoading,
  testID,
  error,
  setSubmitOtpError,
}: ValidateOTPModelProps) => {
  const [otp, setOtp] = useState('')
  const getFormData = (): any[] => {
    const initialFormData = [...otpForm(otp, error, setOtp, setSubmitOtpError)]
    return initialFormData
  }

  const renderAction = ({ handleSubmit }: any) => {
    const handlePress = () => {
      handleSubmit
      onOTPEntered(otp)
    }
    return (
      <Button
        title={'Proceed'}
        type="primary"
        disabled={otp.length !== 6}
        isLoading={isLoading}
        isFull={true}
        onPress={handlePress}
        testID={'proceedBtn'}
      />
    )
  }
  return (
    <ModalDialog
      testID={testID}
      type={'Centered'}
      show={isModelDialogVisible}
      onDismiss={() => {
        setOtp('')
        onDismiss()
      }}>
      <Box {...styles.otpDialog.container}>
        <Text {...styles.otpDialog.tittle}>OTP Validation</Text>
        <Spacer direction="vertical" size={24} />
        <Box width="100%">
          <Text color="LIGHT_BLACK" fontSize={12} fontFamily={'jiotype-medium'}>
            {staticStrings.settingsOtpTitle}
            <Text color="BLACK_21" fontSize={12} fontFamily={'jiotype-medium'}>
              +91 XXXXX X{mobileNum && mobileNum.substring(7, 10)}
            </Text>
          </Text>
        </Box>
        <Spacer direction="vertical" size={32} />

        <Box {...styles.formContainer}>
          <Form
            initialValues={{
              otp: '',
            }}
            container={DefaultFormContainer}
            formData={getFormData()}
            actionButtons={renderAction}
          />
        </Box>
        <Spacer direction="vertical" size={24} />
        <Resend count={30} handleResend={resendOTP} mobile={mobileNum} />
      </Box>
    </ModalDialog>
  )
}

export { ValidateOTPModel }
